import React, { Component } from 'react';
import { withStyles, CssBaseline } from '@material-ui/core';

import styles from '../assets/styles/jss/Home';
import UserReport from '../components/UserReport';

class Reports extends Component {
  render() {
    return (
      <div>
        <CssBaseline />
        <UserReport />
      </div>
    );
  }
}

export default (withStyles(styles)(Reports));
